<div class="ds-onboarding-input">
  <form [formGroup]="formGroup" class="double-input">
    <!-- First Input -->
    <div class="ds-input-primary">
      <div class="ds-input-primary-content">
        <input formControlName="firstInput" [placeholder]="onboardingFlowStep?.placeholder[0]" 
               [ngClass]="{'invalid-input': formGroup.get('firstInput')?.invalid && (formGroup.get('firstInput')?.dirty || formGroup.get('firstInput')?.touched)}"/>
      </div>
      <div class="ds-input-primary-label" *ngIf="formGroup.get('firstInput')?.invalid && (formGroup.get('firstInput')?.dirty || formGroup.get('firstInput')?.touched)">
        <!-- Error Messages for First Input -->
        <ng-container *ngFor="let error of getErrors('firstInput')">
          <span>{{ error }}</span>
        </ng-container>
      </div>
    </div>

    <!-- Second Input -->
    <div class="phone-inputs" style="width: 100%">

      <div class="ds-input-primary">
        <div class="ds-input-primary-content" [ngClass]="{'invalid-input': formGroup.get('secondInput')?.invalid && (formGroup.get('secondInput')?.dirty || formGroup.get('secondInput')?.touched) }">

          <!--<ion-input  placeholder="+XXX" [debounce]="300" [value]="selectedPhone?.dial_code" (ionInput)="setSearchTerm($event)" style="width: 80px" (click)="onExtensionSelectorClick($event)"></ion-input>-->
          
          <!--<input placeholder="+XXX" formControlName="phoneExtension" #triggerInput (input)="setSearchTerm($event)" style="width: 80px" (click)="onExtensionSelectorClick($event)"/>-->

          <input formControlName="secondInput" [placeholder]="onboardingFlowStep?.placeholder[1]" 
                 />
        </div>
        
        <div class="ds-input-primary-label" *ngIf="formGroup.get('secondInput')?.invalid && (formGroup.get('secondInput')?.dirty || formGroup.get('secondInput')?.touched)">
          <!-- Error Messages for Second Input -->
          <ng-container *ngFor="let error of getErrors('secondInput')">
            <span>{{ error }}</span>
          </ng-container>
        </div>

        <!--<div class="ds-input-primary-label" *ngIf="formGroup.get('phoneExtension')?.invalid && (formGroup.get('phoneExtension')?.dirty || formGroup.get('phoneExtension')?.touched)">
          <!~~ Error Messages for Second Input ~~>
          <span *ngIf="formGroup.get('phoneExtension')?.errors?.['required']">Debes introducir una extensión</span>
        </div>
-->
      </div>
    </div>
    
  </form>
</div>

<!--<div #tooltip class="custom-tooltip" *ngIf="tooltipVisible" [ngStyle]="{'top': tooltipPosition.top, 'left': tooltipPosition.left}">
  <app-modal-phone-extension (onSelect)="onSelectPhone($event)" [searchTerm]="searchTerm"></app-modal-phone-extension>
</div>-->